import { Component, Input, OnInit } from '@angular/core';
import { Movie, MoviePress } from '@usheru-hff/shared/domain';
/**
 * Component to display the reviews from a movie.
 */
@Component({
  selector: 'ush-movie-reviews',
  templateUrl: './movie-reviews.component.html',
  styleUrls: ['./movie-reviews.component.scss']
})
export class MovieReviewsComponent implements OnInit {
  /**
   * @docsNotRequired
   */
  @Input() movie: Movie;

  /**
   * @docsNotRequired
   *
   * //TODO barbeitoalex propostal - this could be a getter.
   */
  pressReviews: MoviePress[];

  /**
   * @docsNotRequired
   */
  starsCounter: number[];

  ngOnInit(): void {
    const movieReviews = this.movie?.reviews;
    this.pressReviews = movieReviews || null;
  }

  /**
   * @docsNotRequired
   */
  numToArray(num: number) {
    return new Array(num);
  }
}
